<template>
    <div>
        <router-view />
    </div>
</template>

<script>
    export default {
        name: "SettingsWrapper"
    }
</script>

<style scoped>

</style>